/**
 * The PCs this phone may approve for (docs/android-bridge.md, "Paired
 * approvals"): read when a PC's thread opens (`on`), and kept as the app says
 * a pairing was kept or removed. Null on the web, on a PC, and in an app that
 * cannot pair.
 */

import { useEffect, useState } from 'react';
import { hasBridge, nativePairings, onPairings } from '../android';

export function usePairings(on: boolean): string[] | null {
  const [pcs, setPcs] = useState<string[] | null>(null);
  useEffect(() => {
    if (!on || !hasBridge()) return;
    let live = true;
    void nativePairings().then((read) => live && setPcs(read));
    const off = onPairings((changed) => live && setPcs(changed));
    return () => {
      live = false;
      off();
    };
  }, [on]);
  return pcs;
}
